import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCompropagoComponent } from './simple-icons-compropago.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCompropagoComponent ],
    exports:      [ SimpleIconsCompropagoComponent ],
    bootstrap:    []
})
export class SimpleIconsCompropagoModule {}
